module.exports = __webpack_public_path__ + "media/svg-new/icon-maxq-8db1825f.svg";